import logo from "../../../assets/images/ayawaLogo.png";
import './style.scss'

const Privacy = () => {
    return(
        <div className={'privacy-page'}>
            <img src={logo} className={'logo'}/>
            <div className={'title'}>
                <h1>Privacy Policy</h1>
                <span className={'title-span'}>Effective from 3rd February, 2023</span>
                <p>
                    Ayawa Pty Ltd (“Ayawa”, ‘We”,” Us”) is committed to providing quality services
                    to its users (“You”) and this policy outlines our ongoing obligations to you in respect
                    of how we manage your Personal Information. We have adopted the Australian Privacy
                    Principles (APPs) contained in the Privacy Act 1988 (Cth) (the Privacy Act).
                    The NPPs govern the way in which we collect, use, disclose, store, secure and dispose of your
                    Personal Information. A copy of the Australian Privacy Principles may be obtained
                    from the website of The Office of the Australian Information Commissioner at www.aoic.gov.au
                </p>
            </div>

            <div className={'personal-info'}>
                <h1>What is Personal Information
                    and why do we collect it?</h1>
                <p className={'upper-p'}>
                    Personal Information is information or an opinion that identifies an individual. Examples of Personal Information we collect include: names, addresses, email addresses, phone and facsimile numbers.
                </p>
                <p className={'second-p'}>This Personal Information is obtained in many ways including:</p>
                <div className={'list'}>
                    <ul>
                        <li>Use of the App</li>
                        <li>Via our website at https://www.ayawa.io</li>
                        <li>When you communicate with us via email or complete a survey or provide feedback</li>
                        <li>From data provided You obtained by Your device to which you have given consent; and</li>
                        <li>from third party services utilized by Us.</li>
                    </ul>
                </div>
                <p className={'middle-p'}>We collect your Personal Information for the primary purpose of providing
                    our services to You, to comply with the law and for communicating with you, including marketing communications.
                    We may also use your Personal Information for secondary purposes closely related to the primary purpose,
                    in circumstances where you would reasonably expect such use or disclosure.</p>
                <p className={'middle-p'}>
                    You may unsubscribe from our mailing/marketing lists at any time by contacting us in writing or
                    using the ‘Unsubscribe’ button in any marketing communication but reserve the right to send you
                    notifications related to our services and the operation of the Ayawa App (“the App”).
                </p>
                <p className={'lower-p'}>Personal information we may collect for you includes:</p>
                <div className={'list'}>
                    <ul>
                        <li>Alternate sign up or log-in methods -e.g. Apple or Google ID</li>
                        <li>Device identifier generated by the App</li>
                        <li>Your time spent on the App</li>
                        <li>Content or services accessed by you through the App</li>
                        <li>Web browser information</li>
                        <li>IP address</li>
                        <li>App performance data</li>
                    </ul>
                </div>
            </div>

            <div className={'how-we-use'}>
                <h1>How we use your data</h1>
                <p>We will use Your data to:</p>
                <div className={'list'}>
                    <ul>
                        <li>Provide Our services to you</li>
                        <li>Manage, maintain and operate our business and the App</li>
                        <li>Suggest content or services based on you use of the App</li>
                    </ul>
                </div>

                <p className={'lower-p'}>We will not share or sell your data with third parties other than as specified in this Privacy Policy.</p>
            </div>

            <div className={'sensitive-info'}>
                <h1>Sensitive Information</h1>
                <p>
                    Sensitive information, including health information, will be used by us only:
                </p>
                <div className={'list'}>
                    <ul>
                        <li>For the primary purpose for which it was obtained</li>
                        <li>For a secondary purpose that is directly related to the primary purpose</li>
                        <li>With your consent; or where required or authorized by law.</li>
                    </ul>
                </div>
                <p>The Sensitive Information we may collect from You relates to
                    Your uses of the App and may include data from Apple Health Kit:</p>
                <b>Apple HealthKit</b>
                <p> We use Apple’s HealthKit framework, which provides a central repository for health and
                    fitness data on iPhone and Apple Watch and – with your explicit consent – lets the
                    App communicate with the HealthKit store to access and share this data.
                    If You download and use the Apple Watch version of the Application, We may collect and process your heart rate data, obtained through the
                    HealthKit framework and the Apple CoreMotion processor, with your explicit consent.
                    New data attributes may be added to the HealthKit framework, which will be portrayed in the Application and which You have to consent to.
                </p>
                <p>If You grant the App access to HealthKit, it can add
                    information to certain sections of HealthKit, ie.
                    adding the minutes of meditation that the User is listening
                    to in the Application to the Awareness Time section in HealthKit.
                    This data is collected for the purpose of operation and improvement of the Ayawa service and determining the effectiveness of content provided by Ayawa and selected third-parties.
                    This data will not be released to any third party without your express permission.</p>
            </div>

            <div className={'third-parties'}>
                <h1>Third Parties</h1>
                <p>
                    Where reasonable and practicable to do so, we will collect your Personal Information only from You.
                    However, in some circumstances we may be provided with information by third parties.
                    In such a case we will take reasonable steps to ensure that you are made aware of the information provided to us by the third party.
                </p>
                <p>Third parties who provide us information are set out below</p>
                <div className={'table-div'}>
                    <table className={'table rounded-corners'}>
                        <tbody>
                        <tr>
                            <th>Third Party Service</th>
                            <th>Purpose</th>
                            <th>Privacy Policy</th>
                        </tr>
                        <tr>
                            <td>Apple ID</td>
                            <td>Login and Accesses</td>
                            <td>https://www.apple.com/legal/privacy/en-ww/</td>
                        </tr>
                        <tr>
                            <td>Google ID</td>
                            <td>Login and Accesses</td>
                            <td>https://policies.google.com/privacy?hl=en-US</td>

                        </tr>
                        <tr>
                            <td>Firebase</td>
                            <td>Analytics & Communication</td>
                            <td>https://policies.google.com/privacy?hl=en-US</td>
                        </tr>
                        <tr>
                            <td>Amazon Web Services</td>
                            <td>Data storage</td>
                            <td>https://policies.google.com/privacy?hl=en-US</td>
                        </tr>
                        </tbody>
                    </table>
                    <div className={'table rounded-corners-mobile'}>
                        <div className={'table-body'}>
                            <div className={'row-main'}>
                                <div>Third Party Service</div>
                                <div>Purpose</div>
                                <div>Privacy
                                     Policy</div>
                            </div>
                            <div className={'row-second'}>
                                <div>Apple ID</div>
                                <div>Login and Accesses</div>
                                <div>https://www.
                                    apple.com
                                    /legal/privacy
                                    /en-ww/</div>
                            </div>
                            <div className={'row-third'}>
                                <div>Google ID</div>
                                <div>Login and Accesses</div>
                                <div>https://policies.
                                    google.
                                    com/privacy?
                                    hl=en-US</div>
                            </div>
                            <div className={'row-fourth'}>
                                <div>Firebase</div>
                                <div>Analytics & Communica
                                    tion</div>
                                <div>https://policies.
                                    google.com/
                                    privacy?
                                    hl=en-US</div>
                            </div>
                            <div className={'row-fifth'}>
                                <div>Amazon Web Services</div>
                                <div>Data storage</div>
                                <div>https://policies.
                                    google.com/
                                    privacy?
                                    hl=en-US</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={'disclosure'}>
                <h1>Disclosure of Personal Information</h1>
                <p>Your Personal Information may be disclosed in a number of circumstances including the following:</p>
                <div className={'list'}>
                    <ul>
                        <li>Third parties where you consent to the use or disclosure; and</li>
                        <li>Where required or authorised by law</li>
                    </ul>
                </div>
            </div>

            <div className={'security'}>
                <h1>Security of Personal Information</h1>
                <p>
                    Your Personal Information is stored in a manner that reasonably protects it from misuse and loss and
                    from unauthorized access, modification or disclosure. When Your Personal Information is no longer needed
                    for the purpose for which it was obtained, We will take reasonable steps to destroy or permanently
                    de-identify your Personal Information. However, most of the Personal Information is or will be stored
                    by us for a minimum of 7 years.
                </p>
                <p>All Personal Data is secured at rest using industry standard encryption and data is transmitted over
                    a secure connection.</p>
            </div>

            <div className={'accsess-to-info'}>
                <h1>Access to your Personal Information</h1>
                <p>You may access the Personal Information We hold about you and to update and/or correct it, subject to certain exceptions.
                    If you wish to access your Personal Information, please contact us in writing.</p>
                <p>We will not charge any fee for your access request, but may charge an administrative fee for providing
                    a copy of your Personal Information.</p>
                    <p>
                    In order to protect your Personal Information We may require identification and other evidence from You before releasing the requested information.
                </p>
            </div>

            <div className={'quality-of-info'}>
                <h1>Maintaining the Quality of your Personal Information</h1>
                <p>It is important to us that Your Personal Information is up to date.
                    We will take reasonable steps to make sure that Your Personal Information is accurate, complete and up-to-date.
                    If You find that the information we have is not up to date or is inaccurate,
                    please advise Us as soon as practicable so we can update our records and ensure we can continue to
                    provide quality services to you.</p>
            </div>

            <div className={'note-to-citizens'}>
                <h1>Note to EU citizens and residents</h1>
                <p className={'main-p'}>Your data may be stored in locations outside of the EU, including in countries or jurisdictions,
                such as Australia or the US, where privacy protections are different to those in the EU.
                By using the App, you consent for any personal information to be stored in these locations.</p>

                <b>What are your data protection rights?</b>

                <p className={'main-p'}>We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>
                <p className={'bold-wrapper'}><b className={'bold'}>The right to access</b> – You have the right to request Our Company for copies of your personal data. We may charge you a small fee for this service.</p>
                <p className={'bold-wrapper'}><b className={'bold'}>The right to rectification</b> – You have the right to request that We correct any information You believe is inaccurate. You also have the right to request Us to complete the information You believe is incomplete.</p>
                <p className={'bold-wrapper'}><b className={'bold'}>The right to erasure</b> – You have the right to request that We erase your personal data, under certain conditions.</p>
                <p className={'bold-wrapper'}><b className={'bold'}>The right to restrict processing</b> – You have the right to request that We restrict the processing of your personal data, under certain conditions.</p>
                <p className={'bold-wrapper'}><b className={'bold'}>The right to object to processing</b> – You have the right to object to Our processing of Your personal data, under certain conditions.</p>
                <p className={'bold-wrapper'}><b className={'bold'}>The right to data portability</b> – You have the right to request that We transfer the data that we have collected to another organization, or directly to you, under certain conditions.</p>
                <p className={'main-p'}>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us via the methods set out below</p>
            </div>

            <div className={'updates'}>
                <h1>Policy Updates</h1>
                <p>This Policy may change from time to time and is available on our website and via the Ayawa App.</p>
            </div>

            <div className={'data-control'}>
                <h1>Data Control</h1>
                <p>All data collected is controlled by Ayawa Pty Ltd and related business entities.</p>
            </div>

            <div className={'complaints'}>
                <h1>Privacy Policy Complaints
                    and Enquiries</h1>
                <p>If you have any queries or complaints about our Privacy Policy please contact us at:</p>
                <p>The Data Controller</p>
                <div className={'inner-spans'}>
                    <span>Ayawa Pty Ltd</span>
                    <span>Unit 8 / 35 Biscayne Way</span>
                    <span>Jandakot WA 6164</span>
                    <span>Australia</span>
                </div>
            </div>

        </div>
    )
}
export default Privacy;